import React, { useState } from "react";
import { displayStats } from "../playerStats";

const STATS = ["PAC", "SHO", "PAS", "DRI", "DEF", "PHY"];

export default function SquadList({ roster, slots }) {
  const players = slots
    .map((s) => ({ slot: s, p: roster?.[s.id] }))
    .filter((x) => x.p);

  if (players.length === 0) {
    return <div className="text-xs text-zinc-500">Squad unavailable.</div>;
  }

  return (
    <div>
      {/* stat-label header (shown once) */}
      <div className="flex items-center gap-2 mb-1.5">
        <span className="w-9 shrink-0" />
        <span className="flex-1 min-w-0" />
        <div className="grid grid-cols-6 gap-1 shrink-0 text-center">
          {STATS.map((k) => (
            <span
              key={k}
              className="w-7 text-[8px] font-semibold uppercase tracking-wider text-zinc-600"
            >
              {k}
            </span>
          ))}
        </div>
      </div>

      <div className="space-y-1">
        {players.map(({ slot, p }) => (
          <div key={slot.id} className="flex items-center gap-2">
            <span className="w-9 shrink-0 text-[10px] font-semibold uppercase tracking-wider text-zinc-500">
              {slot.label}
            </span>
            <div className="flex-1 min-w-0 flex items-baseline gap-2">
              <span className="text-xs text-zinc-100 truncate">{p.name}</span>
              {p.club && (
                <span className="hidden sm:inline text-[10px] text-zinc-600 truncate">
                  {p.club}
                  {p.season ? ` · ${p.season}` : ""}
                </span>
              )}
            </div>
            <div className="grid grid-cols-6 gap-1 shrink-0 text-center">
              {displayStats(p).map(({ key, value }) => {
                const mt = p.formMod?.stat === key ? p.formMod.type : null;
                return (
                  <span
                    key={key}
                    title={`${key} ${value ?? "–"}`}
                    className={`w-7 text-[11px] font-semibold tabular-nums ${
                      mt === "form"
                        ? "text-emerald-400"
                        : mt === "injury"
                          ? "text-red-400"
                          : "text-zinc-300"
                    }`}
                  >
                    {value ?? "–"}
                  </span>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Self-contained collapsible squad (used on the ranked result screen).
export function SquadDropdown({ label, roster, slots, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-xl bg-zinc-900/40 border border-zinc-800 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-zinc-900/70 transition"
      >
        <span className="text-sm font-semibold text-zinc-200 truncate flex-1">
          {label}
        </span>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className={`w-4 h-4 text-zinc-500 transition-transform shrink-0 ${open ? "rotate-90" : ""}`}
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
      {open && (
        <div className="border-t border-zinc-800 px-4 py-3">
          <SquadList roster={roster} slots={slots} />
        </div>
      )}
    </div>
  );
}
